export enum eGameStage {
    Dev = 1,
    Early,
    Complete,
    Monetization
}
